<template>
  <div style="background-color: #F8F9FB;">
    <hhead></hhead>
    <crm-nav></crm-nav>
    <div class="jgMsg_box" style="overflow: hidden;">
      <div
        class="jgMsg"
        :style="{
          boxSizing: 'border-box',
          minWidth: '1100px',
          minHeight: MHeight,
        }"
      >
        <div class="fxTop" :style="{ display: display }">
          <div class="left">
            <h2>账户名称：{{ res.userName }}</h2>
            <!-- <div class="prev" @click="prev">
              <i class="iconfont icon-chehui"></i>&nbsp;点击返回
            </div> -->
            <div class="date">
              <span>选择时间段： </span>
              <div class="block">
                <el-date-picker
                  v-model="value1"
                  type="daterange"
                  value-format="yyyy/MM/dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
              <span class="btn1" @click="seeBtn">查看</span>
              <span @click="pushReport" class="btn1">导出评估报告</span>
              <!-- <span class="btn1">导出账户汇总数据</span> -->
            </div>
          </div>
          <div class="right" style="padding-top: 20px;">
            <div>
              <b>累计收益</b>
              <p
                :style="{
                  color: tabL.yearlyProfitRate >= 0 ? '#FA4B22' : '#44C786',
                }"
              >
                {{ tabL.profitRate | sum4 }} <i>%</i>
              </p>
            </div>
            <span></span>
            <div>
              <b>最大回撤</b>
              <p :style="{ color: '#44C786' }">
                {{ tabL.maxLoss | sum4 }} <i>%</i>
              </p>
            </div>
            <span></span>
            <div>
              <b>夏普比率</b>
              <p :style="{ color: '#5B85FF' }">{{ tabL.sharpeRate | sum2 }}</p>
            </div>
            <span></span>
            <div>
              <b>卡玛比率</b>
              <p :style="{ color: '#5B85FF' }">{{ tabL.calmarRate | sum2 }}</p>
            </div>
          </div>
        </div>

        <div class="content_">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="数据分析" name="1">
              <el-row :gutter="10">
                <el-col :lg="24" :xl="8">
                  <div class="boxMsg">
                    <div class="top top1">
                      收益
                      <span class="iconfont icon-question">
                        <p class="title__">
                          <b> 当前收益</b>：统计周期内的绝对收益率；<br />
                          <b> 年化收益</b>：统计期内的年化收益率（一
                          般结合账户操作时间与回撤指标来综合 考量）；<br />
                          <b> 单日最大盈利</b>：统计期内，单个交易日
                          的最大盈利（一般结合单日最大回撤与
                          该投顾的策略来综合考量）；<br />
                          <b>夏普比率</b>：统计周期内的夏普比率，账
                          户风险调整后收益水平以及账户波动率
                          的综合参考指标（目的是计算投资组合
                          每承受一单位总风险，会产生多少的超 额报酬）；<br />
                          <b>索提诺比率</b>：统计周期内的索提诺比率，
                          与夏普比率类似，区别在于索提诺比率
                          更注重相同下行风险的波动率（和夏普
                          比率类似，这一比率越高，表明基金承
                          担相同单位下行风险能获得更高的超额 回报率）。
                        </p>
                      </span>
                    </div>
                    <div class="bottom1" style="color: #F05050;">
                      <div class="bottomT">
                        <div>
                          <span>当前收益</span>
                          <p>{{ tabL.profitRate | sum }}</p>
                        </div>
                        <div>
                          <span>单日最大盈利</span>
                          <p>{{ tabL.maxDailyProfit | sum }}</p>
                        </div>
                        <div>
                          <span>年化收益</span>
                          <p>{{ tabL.yearlyProfitRate | sum }}</p>
                        </div>
                      </div>
                      <div class="bottomB">
                        <div>
                          <span>夏普比率</span>
                          <p>{{ tabL.sharpeRate | sum2 }}</p>
                        </div>
                        <div>
                          <span>索提诺比率</span>
                          <p>{{ tabL.sortinoRate | sum2 }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :lg="24" :xl="8">
                  <div class="boxMsg">
                    <div class="top top2">
                      回撤
                      <span class="iconfont icon-question">
                        <p style="color: #44c786" class="title__">
                          <b>峰值回撤（率）</b
                          >：统计周期内，较前一净值高点的最大回撤比率；<br /><b
                            >本金回撤（率）</b
                          >：统计周期内，期末权益小于账户初始本金的最大回撤金额占初始本金（包含净出入金）的比率（一般作为风险控制方面的参考指标）；<br /><b
                            >单日最大亏损</b
                          >：统计周期内，单个交易日最大亏损；<br /><b
                            >最大连续回撤天数</b
                          >：统计周期内，最大的连续回撤天数；<br /><b
                            >最大回撤修复天数</b
                          >：统计周期内，从前一个净值高点到下一个净值创新高的最大交易天数。
                        </p>
                      </span>
                    </div>
                    <div class="bottom2" style="color: #44C786;">
                      <div class="bottomT">
                        <div>
                          <span>最大回撤</span>
                          <p>{{ tabL.maxLoss | sum }}</p>
                        </div>
                        <div>
                          <span>本金回撤</span>
                          <p>{{ tabL.capitalLoss | sum }}</p>
                        </div>
                        <div>
                          <span>单日最大回撤</span>
                          <p>{{ tabL.maxDailyLosss | sum }}</p>
                        </div>
                      </div>
                      <div class="bottomB">
                        <div>
                          <span>最大连续回撤天数</span>
                          <p>{{ tabL.maxLossContinueTradingDayCount }}</p>
                        </div>
                        <div>
                          <span>最大回撤修复天数</span>
                          <p>{{ tabL.maxLossRepartTradingDayCount }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :lg="24" :xl="8">
                  <div class="boxMsg">
                    <div class="top top3">
                      其他
                      <span class="iconfont icon-question">
                        <p style="color: #3891ec" class="title__">
                          <b>卡玛比率（收益风险比率）</b
                          >：统计周期内，其绝对收益与最大回撤的比率；<br /><b
                            >年化波动率</b
                          >：统计周期内，年化最高收益与最低收益的波动比率；<br /><b
                            >年化下行波动率</b
                          >：统计周期内，回撤期间的年化波动比率；<br /><b
                            >历史最大净值</b
                          >：数据统计期内的最高净值；<br /><b>重仓失效率</b
                          >：统计周期内，重仓操作后的回撤比率（一般作为资金管理能力的参考指标）。
                        </p>
                      </span>
                    </div>
                    <div class="bottom3" style="color: #3891EC;">
                      <div class="bottomT">
                        <div>
                          <span>卡玛比率</span>
                          <p>{{ tabL.calmarRate | sum2 }}</p>
                        </div>
                        <div>
                          <span>年化波动率</span>
                          <p>{{ tabL.yearlyWave | sum }}</p>
                        </div>
                        <div>
                          <span>年化下行波动率</span>
                          <p>{{ tabL.yearlyDownWave | sum }}</p>
                        </div>
                      </div>
                      <div class="bottomB">
                        <div>
                          <span>历史最大净值</span>
                          <p>{{ tabL.maxNetValue | sum1 }}</p>
                        </div>
                        <div>
                          <span>重仓失效</span>
                          <p>{{ tabL.positionFailRate | sum }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <div>
                <div class="echartsBox_" :style="{ display: display }">
                  <div class="echartsBox">
                    <div class="main">
                      <div
                        id="main0001"
                        :style="{ height: '450px', width: MWidth }"
                      ></div>
                    </div>
                  </div>
                  <div class="text">
                    <p>年化收益率{{ tabL.yearlyProfitRate | sum }}</p>
                    <p>夏普比率{{ tabL.sharpeRate | sum }}</p>

                    <p>历史最高净值{{ tabL.maxNetValue | sum1 }}</p>
                    <p>最高持仓占用保证金{{ tabL.maxRatioPosition + '%' }}</p>
                    <p>
                      持仓天数{{
                        tabL.totalDayCount - tabL.positionCountEqualZero
                      }}
                    </p>
                    <p>空仓天数{{ tabL.positionCountEqualZero }}</p>
                    <p>平均持仓占用保证金{{ tabL.avgPosition | sum }}</p>
                  </div>
                </div>

                <div class="echartsBox_" :style="{ display: display }">
                  <div class="echartsBox">
                    <div class="main">
                      <div
                        id="main0002"
                        :style="{ height: '450px', width: MWidth }"
                      ></div>
                    </div>
                  </div>
                  <div class="text">
                    <p>历史最大回撤 {{ tabL.maxLoss | sum }}</p>
                    <p>单日最大回撤 {{ tabL.maxDailyLosss | sum }}</p>
                    <p>
                      本金回撤{{ tabL.capitalLoss | sum }}, 最大连续回撤
                      {{ tabL.maxLossContinueTradingDayCount }}
                      天
                    </p>
                    <p>
                      最大回撤期为 {{ tabL.beginDate | datas }} 至
                      {{ tabL.endDate | datas }}
                    </p>
                    <p>
                      共计{{
                        tabL.maxLossIndex - tabL.maxLossPreMaxNetIndex + 1
                      }}
                      个交易日
                    </p>
                  </div>
                </div>

                <div class="echartsBox_" :style="{ display: display }">
                  <div class="echartsBox">
                    <div class="main">
                      <div
                        id="main0003"
                        :style="{ height: '450px', width: MWidth }"
                      ></div>
                    </div>
                  </div>
                  <div class="text">
                    <p>共计{{ tabL.totalDayCount }}交易日</p>
                    <p>账户峰值波动率为 {{ tabL.maxDailyProfit | sum }}</p>
                    <p>年化波动率 {{ tabL.yearlyWave | sum }},</p>
                  </div>
                </div>

                <div class="echartsBox_" :style="{ display: display }">
                  <div class="echartsBox">
                    <div class="main">
                      <div
                        id="main0004"
                        :style="{ height: '450px', width: MWidth }"
                      ></div>
                    </div>
                  </div>
                  <div class="text">
                    <p>
                      该账户报告期自{{ tabL.beginDate | datas }}至{{
                        tabL.endDate | datas
                      }}，报告期内共计{{ tabL.totalDayCount }}交易日；
                    </p>
                    <p>
                      累计手续费
                      {{ tabL.datas ? tabL.datas[0].sumCommosion : '' }} 元
                    </p>
                    <p>手续费占总盈利 {{ tabL.commosionOfSumProfit | sum }},</p>
                    <p>
                      累计盈亏{{
                        tabL.sumProfitArray
                          ? tabL.sumProfitArray[tabL.sumProfitArray.length - 1]
                          : ''
                      }}元
                    </p>
                    <p>最大累计盈利 {{ tabL.maxsumProfit | sum2 }}元</p>
                  </div>
                </div>

                <div class="echartsBox_" :style="{ display: display }">
                  <div class="echartsBox">
                    <div class="main">
                      <div
                        id="main0005"
                        :style="{ height: '450px', width: MWidth }"
                      ></div>
                    </div>
                  </div>
                  <div class="text">
                    <p class="dotted-desc">
                      最大单日盈利 {{ tabL.maxCurrentProfit | sum2 }} 元
                    </p>
                    <p class="dotted-desc">
                      最大单日亏损 {{ -tabL.maxCurrentLoss | sum2 }} 元
                    </p>
                    <p class="dotted-desc">
                      最大单日手续费 {{ tabL.maxCurrentCommission | sum2 }} 元
                    </p>
                    <p class="dotted-desc">
                      每日平均手续费{{ tabL.aveCommosion | sum2 }} 元
                    </p>
                  </div>
                </div>

                <div class="echartsBox_" :style="{ display: display }">
                  <div class="echartsBox">
                    <div class="main">
                      <div
                        id="main0006"
                        :style="{ height: '450px', width: MWidth }"
                      ></div>
                    </div>
                  </div>
                  <!-- <div class="text"></div> -->
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="信息详情" name="2">
              <div class="divBorder">
                <h4>
                  基本信息
                </h4>
                <div class="textFlex">
                  <p>隶属投顾：{{ res.simpleName }}</p>
                  <p>规模范围：{{ res.capitalScaleName }}</p>
                  <p>开始日期：{{ res.startTime | datas }}</p>
                  <p>结束日期：{{ res.endTime | datas }}</p>
                  <p>
                    累计分红：<span style="color: #FA4B22;">{{
                      res.shareMoney | format
                    }}</span>
                  </p>
                </div>

                <p class="n_p">
                  策略类型：<span
                    style="display: inline-block;font-size: 14px;color: #181e2d;margin-right: 10px;border: 1px solid #7699ff;padding: 0px 10px;border-radius: 4px;background-color: #f6f9ff;color: #5b85ff;"
                    v-for="(item, index) in res.strategyList"
                    >{{ item.strategyName }}</span
                  >
                </p>
              </div>

              <div class="divBorder">
                <h4>
                  合作信息
                </h4>
                <div class="textFlex">
                  <p>合作编号：{{ res.contractNum }}</p>
                  <p>开始日期：{{ contract.startTime | datas }}</p>
                  <p>结束日期：{{ contract.endTime | datas }}</p>
                  <p></p>
                  <p></p>
                </div>
              </div>

              <h4>
                分红记录
              </h4>

              <div class="table">
                <el-table
                  :data="dividendList"
                  :header-cell-style="{ textAlign: 'center' }"
                  border
                  size="medium"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="userCode"
                    label="分红账户"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column align="center" label="分红日期">
                    <template slot-scope="scope">
                      <span>{{ scope.row.shareTime | datas }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="shareMoney" align="right" label="金额">
                    <template slot-scope="scope">
                      <span>{{ scope.row.shareMoney | format }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hhead from '../../header/index';
import crmNav from '../../../../components/crmNav/index';
import './style.css';
const echarts = require('echarts');
var myCharts;
export default {
  components: { hhead, crmNav },
  data() {
    return {
      MHeight: document.documentElement.clientHeight - 94 + 'px',

      res: '',
      dividendList: [],
      display: 'flex',
      tabL: '', //res
      tableList: [],
      data: '',
      shortcuts: [
        {
          text: '最近一周',
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          })(),
        },
        {
          text: '最近一个月',
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          })(),
        },
        {
          text: '最近三个月',
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          })(),
        },
      ],
      value1: '',
      MWidth: '',
      activeName: '1',
      contract: '', //合作信息
      colorArray: [
        '#ec0000',
        '#732acb',
        '#00d4de',
        '#FF7F00',
        '#3f769e',
        '#cda1ac',
        '#4f00a3',
        '#f5b868',
        '#5a8fea',
        '#FFD700',
        '#a06375',
        '#ca0073',
        '#a75602',
        '#000000',
        '#dea195',
        '#732acb',
        '#0000ba',
        '#a7cdc9',
        '#df829a',
        '#8E388E',
        '#ff00ff',
      ],
    };
  },
  filters: {
    datas: function(date) {
      if (date) {
        return (
          date
            .substr(0, 10)
            .replace('/', '年')
            .replace('/', '月') + '日'
        );
      }
    },
    num: function(n) {
      if (n) {
        return (Math.round(n * 10000) / 100).toFixed(2) + '%';
      } else {
        return '';
      }
    },
    sum: function(n) {
      if (n) {
        return (Math.round(n * 10000) / 100).toFixed(2) + '%';
      } else {
        return '0.00%';
      }
    },
    sum1: function(n) {
      if (n) {
        return (Math.round(n * 1000) / 1000).toFixed(4);
      } else {
        return '0.0000';
      }
    },
    sum2: function(n) {
      if (n) {
        return (Math.round(n * 100) / 100).toFixed(2);
      } else {
        return '0.00';
      }
    },
    sum4: function(n) {
      if (n) {
        return (Math.round(n * 10000) / 100).toFixed(2);
      } else {
        return '0.00';
      }
    },
    format: function(n) {
      if (n) {
        return n.toFixed(2);
      } else {
        return '0.00';
      }
    },
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        if (document.documentElement.clientWidth < 1570) {
          this.display = 'block';
        } else {
          this.display = 'flex';
        }
      })();
    };

    this.MWidth =
      document.getElementsByClassName('jgMsg')[0].clientWidth - 300 + 'px';
    // console.log(this.MWidth);
    this.details();

    this.$axios
      .post('/crm/acc/queryLocalShare', {
        //分红记录
        apiToken: this.$store.state.usermsg.apiToken,
        accId: this.$route.query.id,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          this.dividendList = res.data.data;
        }
      });

    this.$axios
      .post('/crm/acc/getAccEval', {
        //账户分析
        apiToken: this.$store.state.usermsg.apiToken,
        id: this.$route.query.id,
      })
      .then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.tabL = res.data.data.res;
          this.value1 = [this.tabL.beginDate, this.tabL.endDate];
          this.worth();
        }
      });
  },

  methods: {
    prev() {
      this.$router.go(-1);
    },
    seeBtn() {
      //查看
      // console.log(this.value1);
      if (this.value1) {
        this.$axios
          .post('/crm/acc/getAccEval', {
            apiToken: this.$store.state.usermsg.apiToken,

            id: this.$route.query.id ? this.$route.query.id : '',

            startTime: this.value1 ? this.value1[0] : '',
            entTime: this.value1 ? this.value1[1] : '',
          })
          .then((res) => {
            // console.log(res);
            if (res.data.code == 200) {
              this.tabL = res.data.data.res;
              this.worth();
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
              })
                .then(() => {})
                .catch(() => {});
            }
          })
          .catch((err) => {
            this.$alert('暂无数据', {
              confirmButtonText: '确定',
              type: 'error',
              center: true,
            })
              .then(() => {})
              .catch(() => {});
          });
      } else {
        this.$alert('请选择日期', {
          confirmButtonText: '确定',
          type: 'error',
          center: true,
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    handleClick() {
      //   if (this.activeName == '2') {
      //     this.worth();
      //   }
    },
    details() {
      //详情接口
      this.$axios
        .post('/crm/acc/queryAllAcc', {
          apiToken: this.$store.state.usermsg.apiToken,
          id: this.$route.query.id,
        })
        .then((res) => {
          console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.res = res.data.data[0];
            this.$axios
              .post('/crm/contract/queryOneContract', {
                apiToken: this.$store.state.usermsg.apiToken,
                entConId: res.data.data[0].contractId,
              })
              .then((result) => {
                // console.log(result);
                if (result.data.code == 200) {
                  this.contract = result.data.data;
                }
              });
          }
        });
    },
    pushReport() {
      console.log(this.value1);
      //导出评估报告
      window.open('_blank').location.href = `/crm/report?id=${
        this.$route.query.id
      }&startTime=${this.value1[0]
        .substr(0, 10)
        .replace(/\//g, '')}&entTime=${this.value1[1]
        .substr(0, 10)
        .replace(/\//g, '')}`;
    },
    worth() {
      var option0 = {
        // graphic: graphic,
        title: {
          text: '净值与持仓',
          textStyle: {
            fontWeight: 'normal',
          },
          left: 'left',
        },
        tooltip: {
          trigger: 'axis',
          // formatter: function (params) {
          //     var res = params[0].name+"<br/>";
          //     res += getColor(params[0])+params[0].seriesName+"："+params[0].value+"<br/>";
          //     res += getColor(params[1])+params[1].seriesName+"："+params[1].value+"%<br/>";
          //     return res;
          // },
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: 30,
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: { show: window.innerWidth > 500 },
          },
        },
        legend: {
          data: ['净值', '持仓'],
          right: 40,
        },
        xAxis: [
          {
            type: 'category',
            axisPointer: {
              type: 'shadow',
            },
            data: this.tabL.dateArray,
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '净值',
            scale: true,

            splitNumber: 6,
            position: 'right',
          },
          {
            type: 'value',
            name: '持仓',
            scale: true,

            max: 100,
            interval: 10,
            position: 'left',
            splitLine: { show: true },
            axisLabel: {
              formatter: '{value} %',
            },
          },
        ],
        color: ['red', '#5599FF'],
        series: [
          {
            name: '净值',
            type: 'line',
            symbol: 'none',
            lineStyle: {
              normal: {
                width: 3,
                shadowColor: 'rgba(0,0,0,0.4)',
                shadowBlur: 10,
                shadowOffsetY: 10,
              },
            },
            data: this.tabL.netValueArray,
          },
          {
            name: '持仓',
            type: 'bar',
            symbol: 'none',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#188df0' },
                  { offset: 0.5, color: '#188df0' },
                  { offset: 1, color: '#83bff6' },
                ]),
              },
            },
            data: this.tabL.positionArray,
          },
        ],
      };

      var option1 = {
        title: {
          text: '净值与回撤',
          textStyle: {
            fontWeight: 'normal',
          },
          left: 'left',
        },
        // title: {
        //     text: '净值与回撤',
        //     textStyle: {
        //         fontWeight : 'normal'
        //     },
        //     left:'left'
        // },
        // graphic: graphic,
        toolbox: {
          feature: {
            saveAsImage: { show: window.innerWidth > 500 },
          },
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            // // console.log(params);
            var res = params[0].name + '<br/>';
            var netvalue = '';
            var lossValue = '';
            if (params[0].seriesName == '净值') {
              netvalue =
                params[0].value != '-' ? params[0].value : params[1].value;
              lossValue = params[2].value;
            } else {
              netvalue =
                params[1].value != '-' ? params[1].value : params[2].value;
              lossValue = params[0].value;
            }
            res += '净值 :' + netvalue + '<br/>';
            res += '回撤 :' + lossValue + '%<br/>';
            return res;
          },
        },
        grid: [
          {
            left: '3%',
            right: '3%',
            bottom: '40%',
            height: '45%',
          },
          {
            left: '3%',
            right: '3%',
            bottom: '7%',
            height: '30%',
          },
        ],
        legend: {
          data: ['净值', '历史回撤'],
          right: 40,
        },
        axisPointer: {
          link: [
            {
              xAxisIndex: [0, 1],
            },
          ],
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: { show: false },
            axisLabel: { show: false },
            axisTick: { show: false },
            axisLine: { onZero: false },
            data: this.tabL.dateArray,
          },
          {
            type: 'category',
            gridIndex: 1,
            boundaryGap: false,
            axisLine: { onZero: false },
            data: this.tabL.dateArray,
          },
        ],
        yAxis: [
          {
            name: '',
            scale: true,
            splitNumber: 3,
            axisLabel: {},
            type: 'value',
            position: 'right',
          },
          {
            name: '',
            gridIndex: 1,
            splitNumber: 2,
            boundaryGap: ['20%', '0%'],
            type: 'value',
            // max : 1,
            axisLabel: {
              formatter: '{value} %',
            },
            position: 'right',
          },
        ],
        // color:['red','#5599FF'],
        series: [
          {
            name: '净值',
            type: 'line',
            animation: false,
            symbol: 'none',
            lineStyle: {
              normal: {
                color: 'red',
                width: 3,
                shadowColor: 'rgba(0,0,0,0.4)',
                shadowBlur: 10,
                shadowOffsetY: 10,
              },
            },
            data: this.tabL.netValueArrayRed,
          },
          {
            name: '净值',
            type: 'line',
            animation: false,
            symbol: 'none',
            lineStyle: {
              normal: {
                color: '#53FF53',
                width: 3,
                shadowColor: 'rgba(0,0,0,0.4)',
                shadowBlur: 10,
                shadowOffsetY: 10,
              },
            },
            data: this.tabL.netValueArrayGree,
          },
          {
            name: '历史回撤',
            type: 'line',
            animation: false,
            xAxisIndex: 1,
            yAxisIndex: 1,
            symbol: 'none',
            connectNulls: true,
            itemStyle: {
              normal: {
                color: function(o) {
                  return '#5599FF';
                },
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#5599FF' },
                  { offset: 1, color: '#FF5B4A' },
                ]),
              },
            },
            lineStyle: {
              width: 1,
            },
            data: this.tabL.hisLossArray,
          },
        ],
      };

      var option2 = {
        title: {
          text: '日净值波动',
          textStyle: {
            fontWeight: 'normal',
          },
          left: 'left',
        },
        // graphic: graphic,
        tooltip: {
          title: {
            text: '日净值波动',
            textStyle: {
              fontWeight: 'normal',
            },
            left: 'left',
          },
          trigger: 'axis',
          formatter: function(params) {
            var res = params[0].name + '<br/>';
            res += '日净值波动:' + params[0].value + '%<br/>';
            return res;
          },
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: 30,
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: { show: window.innerWidth > 500 },
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.tabL.dateArray,
        },
        yAxis: {
          axisLabel: {
            formatter: '{value} %',
          },
          position: 'right',
        },
        series: [
          {
            data: this.tabL.netDailyProfitArray,
            itemStyle: {
              normal: {
                shadowBlur: 10,
                shadowColor: 'rgba(120, 36, 50, 0.5)',
                shadowOffsetY: 5,
                color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [
                  {
                    offset: 0,
                    color: 'rgb(251, 118, 123)',
                  },
                  {
                    offset: 1,
                    color: 'rgb(204, 46, 72)',
                  },
                ]),
              },
            },
            symbolSize: function(data) {
              var a = Math.abs(data);
              var size = 10;
              size = size + (a / 30) * 5;
              if (size > 50) size = 50;
              return size;
            },
            type: 'scatter',
          },
        ],
      };

      var option3 = {
        title: {
          text: '累计盈亏与手续费',
          textStyle: {
            fontWeight: 'normal',
          },
          left: 'left',
        },
        // graphic: graphic,
        tooltip: {
          formatter: this.data.formatterTip,
          trigger: 'axis',
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: 30,
          containLabel: true,
        },
        legend: {
          data: ['盈亏', '手续费'],
          right: 40,
        },
        toolbox: {
          feature: {
            saveAsImage: { show: window.innerWidth > 500 },
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.tabL.dateArray,
        },
        yAxis: {
          name: '单位：元',
          type: 'value',
          position: 'right',
        },
        color: ['red', '#5599FF'],
        series: [
          {
            name: '盈亏',
            type: 'line',
            symbol: 'none',
            lineStyle: {
              normal: {
                width: 3,
                shadowColor: 'rgba(0,0,0,0.4)',
                shadowBlur: 10,
                shadowOffsetY: 10,
              },
            },
            itemStyle: {
              normal: {
                color: 'red',
              },
            },
            data: this.tabL.sumProfitArray,
          },
          {
            name: '手续费',
            type: 'line',
            smooth: true,
            symbol: 'none',
            sampling: 'average',
            itemStyle: {
              normal: {
                color: '#428bed',
              },
            },
            lineStyle: {
              width: 1,
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#428bed',
                  },
                  {
                    offset: 1,
                    color: '#81e0fb',
                  },
                ]),
              },
            },
            data: this.tabL.sumCommissionArray,
          },
        ],
      };

      var option4 = {
        title: {
          text: '当日盈亏与手续费',
          textStyle: {
            fontWeight: 'normal',
          },
          left: 'left',
        },
        // graphic: graphic,
        toolbox: {
          feature: {
            saveAsImage: { show: window.innerWidth > 500 },
          },
        },
        tooltip: {
          formatter: this.data.formatterTip,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: 30,
          containLabel: true,
        },
        legend: {
          data: ['盈亏', '手续费'],
          right: 40,
        },
        xAxis: {
          type: 'category',
          data: this.tabL.dateArray,
        },
        yAxis: [
          {
            name: '单位：元',
            type: 'value',
            position: 'right',
          },
        ],
        color: ['red', '#5599FF'],
        series: [
          {
            name: '盈亏',
            type: 'bar',
            barMaxWidth: 50,
            barGap: 0,
            itemStyle: {
              normal: {
                color: function(o) {
                  if (o.value >= 0) {
                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: '#FF0033',
                      },
                      {
                        offset: 1,
                        color: '#FF6666',
                      },
                    ]);
                  } else {
                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: '#66CC99',
                      },
                      {
                        offset: 1,
                        color: '#339933',
                      },
                    ]);
                  }
                },
              },
            },
            data: this.tabL.dailyProfitArray,
          },
          {
            name: '手续费',
            type: 'bar',
            // yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: '#428bed',
              },
            },
            data: this.tabL.commissionArray,
          },
        ],
      };

      var // 逐月盈亏
        option5 = {
          title: {
            text: '逐月盈亏',
            textStyle: {
              fontWeight: 'normal',
            },
            left: 'left',
          },
          //   graphic: graphic,
          toolbox: {
            feature: {
              saveAsImage: { show: window.innerWidth > 500 },
            },
          },
          tooltip: {
            trigger: 'axis',
            formatter: this.data.formatterTip,
            axisPointer: {
              type: 'shadow',
            },
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: 30,
            containLabel: true,
          },
          // legend: {
          //     data:['盈亏','手续费'],
          //    right:40
          // },
          xAxis: {
            type: 'category',
            data: this.tabL.monthProfitDateArray,
          },
          yAxis: [
            {
              boundaryGap: ['5%', '5%'],
              name: '单位：元',
              type: 'value',
              position: 'right',
            },
          ],
          // color:['red','#5599FF'],
          series: [
            {
              name: '盈亏',
              type: 'bar',
              barMaxWidth: 50,
              // lable : {
              //     formatter : function (p) {
              //         return p.value.numberFormat(0);
              //     }
              // },
              barGap: 0,
              itemStyle: {
                normal: {
                  color: function(o) {
                    if (o.value >= 0) {
                      return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: '#FF0033',
                        },
                        {
                          offset: 1,
                          color: '#FF6666',
                        },
                      ]);
                    } else {
                      return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: '#66CC99',
                        },
                        {
                          offset: 1,
                          color: '#339933',
                        },
                      ]);
                    }
                  },
                },
              },
              data: this.tabL.monthProfitArray,
            },
          ],
        };

      var chartDom = document.getElementById('main0001');
      var chartDom2 = document.getElementById('main0002');
      var chartDom3 = document.getElementById('main0003');
      var chartDom4 = document.getElementById('main0004');
      var chartDom5 = document.getElementById('main0005');
      var chartDom6 = document.getElementById('main0006');
      var myChart0 = echarts.init(chartDom);
      var myChart2 = echarts.init(chartDom2);
      var myChart3 = echarts.init(chartDom3);
      var myChart4 = echarts.init(chartDom4);
      var myChart5 = echarts.init(chartDom5);
      var myChart6 = echarts.init(chartDom6);
      myChart0.setOption(option0);
      myChart2.setOption(option1);
      myChart3.setOption(option2);
      myChart4.setOption(option3);
      myChart5.setOption(option4);
      myChart6.setOption(option5);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/crm/user/details/index.vue